module.exports = __webpack_public_path__ + "static/idea-option_color-logo-bed5a6c746b35496357441141efe1785.png";